import { createLinkedEntity } from "@/modules/meetings/utils/index";
/**
 * Creates custom handlers for TaskFormFields in multiple tasks scenario
 * Each handler updates both the form state and the task data
 */
export const handleMultipleTasks = (
  handlers: any,
  taskId: number,
  onTaskChange: (id: number, field: string, value: any) => void,
  formState: any
) => {
  return {
    ...handlers,
    onDateChange: (date: Date | null) => {
      handlers.onDateChange?.(date);
      onTaskChange(taskId, "dueDate", date);
    },
    onTimeChange: (time: string) => {
      handlers.onTimeChange?.(time);
      onTaskChange(taskId, "selectedTime", time);
    },
    onLinkToChange: (value: any) => {
      formState.setters.setLinkTo?.(value);
      onTaskChange(taskId, "linkTo", value);
    },
    onPropertyChange: (linkTo: any, property: any, onChange: any) => {
      handlers.onPropertyChange?.(linkTo, property, onChange);
      onTaskChange(taskId, "selectedProperty", property);
      onTaskChange(taskId, "linkToEntity", property?.displayName || "");

      // Create linked entity from property
      if (property) {
        const linkedEntity = createLinkedEntity(
          property.compound || property.label,
          property.uid,
          property.compound || property.label,
          property.id,
          linkTo || "property"
        );
        onTaskChange(taskId, "linkedEntities", [linkedEntity]);
      } else {
        onTaskChange(taskId, "linkedEntities", []);
      }
    },
    onLeadChange: (event: any, linkTo: any, options: any[], onChange: any) => {
      handlers.onLeadChange?.(event, linkTo, options, onChange);
      const value = event.target.value;
      onTaskChange(taskId, "linkToEntity", value);

      // Extract the selected lead and create linked entity
      if (value) {
        const selectedOption = options.find((option) => option.value === value);
        if (selectedOption) {
          const linkedEntity = createLinkedEntity(
            selectedOption.label,
            selectedOption.uid,
            selectedOption.label,
            selectedOption.value,
            linkTo
          );
          onTaskChange(taskId, "linkedEntities", [linkedEntity]);
        }
      } else {
        onTaskChange(taskId, "linkedEntities", []);
      }
    },
    // Pass through search handlers
    onPropertiesSearch: handlers.onPropertiesSearch,
    onLeadsSearch: handlers.onLeadsSearch,
    onUsersSearch: handlers.onUsersSearch,
    onTypeChange: (event: any) => {
      onTaskChange(taskId, "type", event.target.value);
    },
    onUserChange: (event: any) => {
      onTaskChange(taskId, "userUId", event.target.value);
    },
  };
};
